<template>
  <Button
    variant="custom"
    label="invite contractor to estimate"
    height="24px"
    borderColor="#FFA500"
    activeBgColor="#FFF"
    activeFontColor="#FFA500"
    fontSize="12px"
    fontWeight="700"
    width="auto"
    :isCapitalize="true"
    :disabled="
      (isLockTemplateModifiedChecker &&
        !currentJobDetails?.isHistoricProject) ||
      !isUserHasEstimateEditAccess
    "
  >
    <template #prefix>
      <TradeAvatarWithPlusYellow />
    </template>
  </Button>
</template>
<script setup>
import Button from "@/core/components/ui/general/Button.vue";
import TradeAvatarWithPlusYellow from "@/core/components/icons/TradeAvatarWithPlusYellow.vue";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
import { computed } from "vue";
import { useStore } from "vuex";
import { JOBS_STORE } from "@/store/modules/jobs";
const store = useStore();
const currentJobDetails = computed(
  () => store.getters[`${JOBS_STORE}/getJobDetails`]
);

const isLockTemplateModifiedChecker = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/getIsEstimateSubmitted`]
);
const isUserHasEstimateEditAccess = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/isUserHasEstimateEditAccess`]
);
</script>
<script>
export default {
  name: "AddContractorButton",
};
</script>
